(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('click', (event) => {
    const wishlistBtn = event.target.closest('.coa-wishlist-btn');
    if (!wishlistBtn) return;
    event.preventDefault();
    wishlistBtn.classList.toggle('is-active');
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.coa-atc-form');
    if (!form) return;

    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    if (!button || button.disabled) return;

    const originalText = button.textContent;
    button.classList.add('is-loading');
    button.textContent = 'Adding...';

    try {
      const response = await fetch(window.Shopify?.routes?.root ? `${window.Shopify.routes.root}cart/add.js` : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: form.querySelector('[name="id"]').value,
          quantity: 1,
        }),
      });

      if (!response.ok) throw new Error('Add to cart failed');

      button.textContent = 'Added!';
      document.dispatchEvent(new CustomEvent('cart:refresh'));

      setTimeout(() => {
        button.textContent = originalText;
        button.classList.remove('is-loading');
      }, 1500);
    } catch (error) {
      button.textContent = 'Try again';
      button.classList.remove('is-loading');
      setTimeout(() => {
        button.textContent = originalText;
      }, 1500);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
